import { sortDestinationIdFormat } from "@redotech/redo-ids-cockroach";
import { SortDispositionSchema } from "@redotech/redo-model/wms/schema/sort-disposition";
import * as z from "zod";

/**
 * Account-scoped list of configured sort destinations for the operator to pick
 * from when binding totes or sorting items at a station (no resolver — the
 * operator chooses the destination by hand).
 */
export const listSortDestinations = {
  name: "listSortDestinations" as const,
  input: z.object({}),
  output: z.object({
    destinations: z.array(
      z.object({
        id: sortDestinationIdFormat.schema,
        name: z.string(),
        disposition: SortDispositionSchema,
      }),
    ),
  }),
};
